// Updates only states for the selected trailer in Select component
const handleTrailerSelect = ({selectedTrailer, setFormData, dispatchForm}) => {
  if (!selectedTrailer) {
    setFormData((prev) => ({
      ...prev,
      trailerNumber: "",
      trailerPlate: "",
      trailerRepairs: null,
      trailerCondition: "",
      trailerOption: null,
      trailerAsset: null,
    }));
    return;
  }

  const hasRepairsOpen = selectedTrailer.trailerRepairs?.length > 0;

  setFormData((prev) => ({
    ...prev,
    trailerNumber: selectedTrailer.label,
    trailerPlate: selectedTrailer.licensePlate,
    trailerRepairs: selectedTrailer.trailerRepairs,
    trailerCondition: hasRepairsOpen ? "under-repair" : prev.trailerCondition,
    trailerOption: selectedTrailer,
    trailerAsset: selectedTrailer.value,
  }));

  if (hasRepairsOpen)
    dispatchForm({
      type: "ERROR_MESSAGE",
      key: "trailerErrorMessage",
      payload: null,
    });
};

export default handleTrailerSelect;